import { useQuery } from '@tanstack/react-query';

import { InvoiceData, paymentRequests } from '../api/payment/api';
import cacheQueryKeys from '../resources/queryCacheKeys';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';
import { useToastController } from '../toast';
import { statusCodesMapper } from '../utils/exception';

import { useRedirectAfterConfirmation } from './useRedirectAfterConfirmation';

export const useInvoice = (invoiceToken?: string) => {
  const { dispatch, actions } = useOnlineBookingReducer();
  const { showToast } = useToastController();
  const { redirect, hasRedirectUrl } = useRedirectAfterConfirmation();

  const query = useQuery<InvoiceData | null>([cacheQueryKeys.OnlineBookingInvoices], async () => {
    if (!invoiceToken) return null;

    const response = await paymentRequests.fetchInvoice(invoiceToken);
    return statusCodesMapper(response, {
      unhandled: () => {
        showToast('There was an error while fetching an invoice.');
        throw new Error();
      },
      success: (data) => {
        if (data.dueAmount === 0) {
          if (hasRedirectUrl) {
            redirect();
          } else {
            dispatch(actions.setSuccess());
          }
        }
        return data;
      },
    });
  });
  return query;
};
